// @flow
import FormHeaderTeam from 'components/FormCustomer/FormHeaderTeam'
import { ResourceResponseContext } from 'components/ResourceFill/providers/ResourceResponseProvider'
import { ResourceSharedContext } from 'components/ResourceFill/providers/ResourceSharedProvider'
import * as React from 'react'

function ResourceFillHeader(): React.Node {
  const { mode } = React.useContext(ResourceSharedContext) || {}
  const { response } = React.useContext(ResourceResponseContext) || {}

  if (mode === 'office' || mode === 'internal') return null

  return <FormHeaderTeam team={response?.team_details} />
}

export default ResourceFillHeader
